import React from 'react';

/**
 * Shop front used by the Butikker entry in the desktop menu: an awning with
 * scallops over a shop with a door. Drawn on the same 16×16 grid as the
 * category icons, with their line weight (1.2) and rounded corners. The lines
 * are strokes, so fill is switched off inline: the global `svg { fill:
 * currentColor }` rule would otherwise fill the shapes.
 */
const IconStore = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    role="presentation"
    aria-hidden="true"
    {...props}
  >
    <g
      style={{ fill: 'none' }}
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1.2 5.6 2.6 2.2a.9.9 0 0 1 .83-.56h9.14a.9.9 0 0 1 .83.56l1.4 3.4" />
      <path d="M1.2 5.6a1.7 1.7 0 0 0 3.4 0 1.7 1.7 0 0 0 3.4 0 1.7 1.7 0 0 0 3.4 0 1.7 1.7 0 0 0 3.4 0" />
      <path d="M2.4 8.4v4.9c0 .5.4.9.9.9h9.4c.5 0 .9-.4.9-.9V8.4" />
      <path d="M6.4 14.2v-3.3c0-.33.27-.6.6-.6h2c.33 0 .6.27.6.6v3.3" />
    </g>
  </svg>
);

export default IconStore;
